import * as state from '../core/state';
import { client } from '../core/mqtt';
// @ts-ignore
import goodGirlAudio from '../../assets/audio/good_girl.mp3';
// @ts-ignore
import bambiFreezeAudio from '../../assets/audio/bambi_freeze.mp3';

export const soundUrls = new Map<string, string>();
soundUrls.set('good_girl.mp3', goodGirlAudio);
soundUrls.set('bambi_freeze.mp3', bambiFreezeAudio);

// Você precisará criar esses arquivos em /assets/audio/
export const soundList = [
    'good_girl.mp3',
    'bambi_freeze.mp3',
];

const soundboardDiv = document.getElementById('soundboard') as HTMLDivElement;

function playSound(soundId: string) {
    if (!state.userKeyPair || !state.userPublicKey || !state.userFingerprint) {
        console.warn('Cannot play sound: User keys missing.');
        return;
    }

    if (!state.activeConversationPartner) {
        console.warn('Cannot play sound: No active conversation selected.');
        return;
    }

    const conversationTopic = `bambi/${state.activeConversationPartner}`;

    const soundMessage = {
        type: 'playSound',
        name: state.userName,
        soundId: soundId,
        publicKey: state.userPublicKey
    };

    client.publish(conversationTopic, JSON.stringify(soundMessage), (err) => {
        if (err) {
            console.error('Error publishing sound message:', err);
        } else {
            console.log(`Sent request to play ${soundId}`);
        }
    });
}

export function initSoundboard() {
    if (!soundboardDiv) return;

    soundList.forEach(soundId => {
        const soundButton = document.createElement('button');
        soundButton.textContent = soundId.split('.')[0];
        soundButton.classList.add('sound-button');
        soundButton.addEventListener('click', () => playSound(soundId));
        soundboardDiv.appendChild(soundButton);
    });
}
